<template>
  <div class="container">
    <head-nav-bar
      title="预约挂号结果"
      :fixed="true"
      @click-left="onLeftClick"
    />
    <div class="mt-header-nav">
      <div class="">
        <div style="text-align:center;padding: 0.3rem;">
          <div class="color-red" style="font-size:1rem;">
            {{ info.bookingNo }}
          </div>
          <div class="text-less">挂号凭证号</div>
        </div>
        <div class="kong"></div>
        <div class="box">
          <div class="label-title">订单信息</div>
          <cell-box style="padding: 0.3rem 0;">
            <!-- <cell-item label="订单编号：" :value="info.BillNo" /> -->
            <cell-item label="支付状态：" :value="info.payStatusDesc" />
            <cell-item label="挂号方式" :value="info.bookingMethodDesc" />
            <cell-item label="挂号医院：" :value="info.hospitalName" />
            <cell-item label="挂号科室：" :value="info.departmentName" />
            <cell-item label="挂号医生：" :value="info.doctorName" />
            <cell-item label="就诊日期：" :value="info.date" />
            <cell-item
              label="门诊类型："
              :value="info.DoctorNoSourceTypeDesc"
            />
            <cell-item label="排队号数：" :value="info.sortIndex" />
            <cell-item label="就诊地址：" :value="info.waitingAddress" />
            <cell-item label="挂号日期：" :value="info.createdTime" />
          </cell-box>
        </div>
        <div class="kong"></div>
        <div class="box">
          <div class="label-title">就诊人信息</div>
          <cell-box style="padding: 0.3rem 0;">
            <cell-item label="就诊人：" :value="info.cardholderName" />
            <cell-item label="出生日期：" :value="info.patientBirthday" />
            <cell-item label="手机号：" :value="info.phoneNo" />
          </cell-box>
        </div>
        <div class="kong"></div>
        <div
          v-if="type === 0 && (info.canPay || info.canCancel)"
          class="footer-actions"
        >
          <van-button size="small" v-if="info.canPay" @click="toPay"
            >支付</van-button
          >
          <van-button
            size="small"
            style="margin-left:0.3rem;"
            v-if="info.canCancel"
            @click="cancel"
            >取消订单</van-button
          >
          <!-- <van-button type="primary" size="small" style="margin-left:0.3rem;"
            >订单改签</van-button -->
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Icon, NoticeBar, Dialog } from "vant";
import { CellBox, CellItem } from "@/components/cell";
import urls from "@/api/url";

export default {
  name: "Confirm",
  components: {
    CellBox,
    CellItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
  },

  data() {
    return {
      Id: "",
      info: {
        typeName: "门诊诊查费",
        money: 100,
      },
      canCancel: false,
    };
  },
  created() {
    this.Id = this.$route.query.Id;
    this.type = this.$route.query.type;
    if (this.Id) {
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.$post("Booking_Detaile", {
        Id: this.Id,
      }).then(res => {
        this.info = res.data;
        this.info.date =
          res.data.bookingDate +
          " " +
          res.data.startBookingTime +
          "~" +
          res.data.endBookingTime;
        this.info.patientBirthday = this.info.patientBirthday
          ? this.info.patientBirthday
          : "";
      });

      //this.info.CanPay = true;
    },
    toPay() {
      this.$router.push({
        name: "servePreOrderPay",
        query: { Id: this.info.id },
      });
    },
    cancel() {
      Dialog.confirm({
        message: "确认取消该订单吗？",
      })
        .then(() => {
          this.$post(this.$config.payUrl + urls.PayCancel, {
            Id: this.Id,
          }).then(() => {
            this.$toast.success("取消成功！");
            this.$router.push({
              name: "userOrderList",
            });
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    onLeftClick() {
      this.$router.push({
        name: "userOrderList",
        query: {
          tab: this.type,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  font-size: 0.5rem;
  text-align: center;
  padding: 0.5rem;
  .icon {
    font-size: 0.6rem;
    color: @green;
  }
}
</style>
